import '../css/style.scss';

// Our modules / classes
import Search from './modules/Search';
import Announcements from './modules/Announcements';
// Instantiate a new object using our modules/classes
const search = new Search();
const announcements = new Announcements();
